import { validImageExtensions } from './imageTypes';

// lowercase only, keep this list of valid file types lowercase
const validFileTypes: string[] = [
  ...validImageExtensions,
  'csv',
  'doc',
  'docx',
  'docm',
  'key',
  'numbers',
  'pages',
  'pdf',
  'png',
  'ppt',
  'pptx',
  'pptm',
  'ppsm',
  'rtf',
  'txt',
  'xls',
  'xlsx',
  'xlsm',
  'xlsb',
  'zip',
];

export default validFileTypes;
